<template>
<span class="keepSpaces" v-if="showValue" :style="{'color': color}">{{ value }}<v-icon :tabindex="editOnFocus || editOnEnter ? 0 : null" class="pl-1" v-if="editable" @click="$emit('edit')" @focus="onFocus" @keydown.enter.stop="onEnterPressed" ref="edit1">edit</v-icon></span>
<span class="transparentText" v-else>N/A
    <v-icon :tabindex="editOnFocus || editOnEnter ? 0 : null" class="pl-1" v-if="editable" @click="$emit('edit')" @focus="onFocus" @keydown.enter.stop="onEnterPressed" ref="edit2">edit</v-icon></span>
</template>

<script>
import UtilService from '@/services/utilService.js';

export default {
    props: [
        'value',
        'editable',
        'color',
        'editOnFocus',
        'editOnEnter'
    ],
    computed: {
        showValue() {
            return !UtilService.isNullOrEmpty(this.value);
        }
    },
    methods: {
        onFocus() {
            if (this.editOnFocus) {
                this.$emit('edit');
            }
        },
        onEnterPressed() {
            if (this.editOnEnter) {
                this.$emit('edit');
            }
        }
    }
}
</script>

<style scoped>
.transparentText {
    color: rgba(0, 0, 0, 0.3);
}

.keepSpaces {
    white-space: pre-wrap; /* css-3 */
    white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
    white-space: -pre-wrap; /* Opera 4-6 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* Internet Explorer 5.5+ */    
}
</style>
